import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import vuetify_settings from '../../../axxez-plugin/plugins/vuetify';

Vue.use(Vuetify);

export default new Vuetify(vuetify_settings);
